/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::398607da20751a97774109d098b7c919>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "ArrowsDiagonalUpRightDownLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Used within Jira Pages to connect or switch to a Space or page.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const ArrowsDiagonalUpRightDownLeftIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1h5.25a.75.75 0 0 1 .75.75V7H8.5V3.56l-6.47 6.47L.97 8.97 7.44 2.5H4zm3.5 11.44 6.47-6.47 1.06 1.06-6.47 6.47H12V15H6.75a.75.75 0 0 1-.75-.75V9h1.5z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
ArrowsDiagonalUpRightDownLeftIcon.displayName = 'ArrowsDiagonalUpRightDownLeftIcon';
var _default = exports.default = ArrowsDiagonalUpRightDownLeftIcon;